import { doc, runTransaction } from 'firebase/firestore'
import { firestore, withActor } from '../backend'

// BS-2293 : le tableau `connect` (etablissements/{id} ou users/{id}) est partagé
// par tous les connecteurs (gmail, gcalendar, stripe, pennylane, ...). Le
// reconstruire depuis une copie en mémoire du document puis l'écrire en bloc
// écrase toute entrée ajoutée entre-temps : connecter Google Calendar après
// Gmail effaçait Gmail (closure périmée sur selectedVenue). On relit donc
// toujours le document dans une transaction avant d'écrire.
//
// Ordre : une entrée existante est remplacée à sa place (pas déplacée en fin).
// Les lecteurs cherchent par `id`, l'ordre n'a pas de sens métier.
const isEntry = c => !!c && typeof c === 'object'

const mutateConnect = (collectionName, id, mutate) =>
	runTransaction(firestore, async tx => {
		const ref = doc(firestore, collectionName, id)
		const snap = await tx.get(ref)
		const current = snap.data()?.connect
		tx.update(ref, withActor({ connect: mutate(Array.isArray(current) ? current.filter(isEntry) : []) }))
	})

// Remplace l'entrée de même `id`, ou l'ajoute en fin de tableau.
// `preserve` : champs à reprendre de l'entrée vivante (tokens rafraîchis côté
// serveur, ex. BEX) plutôt que de la copie mémoire du client.
export const upsertConnector = (collectionName, id, connector, { preserve = [] } = {}) =>
	mutateConnect(collectionName, id, connect => {
		const existing = connect.find(c => c.id === connector.id)
		if (!existing) return [...connect, connector]
		const kept = {}
		preserve.forEach(key => {
			if (key in existing) kept[key] = existing[key]
		})
		return connect.map(c => (c.id === connector.id ? { ...connector, ...kept } : c))
	})

export const removeConnector = (collectionName, id, connectorId) =>
	mutateConnect(collectionName, id, connect => connect.filter(c => c.id !== connectorId))
